import React from "react";
import CListItem from "@mui/material/ListItem";
const ListItem = (props) => {
  return <CListItem {...props}></CListItem>;
};

export default ListItem;
